import {styled} from '@mui/material/styles';

export default function CN() {
    return (
        <Agreement>
            <h1>📄 投資者協議</h1>
            <h2>IGE RWA供應鏈金融投資者投資協議</h2>
            <p><strong>版本號：</strong>IGE-RWA-2025V1.0</p>
            <p><strong>生效日期：</strong>該簽名上鏈後即生效</p>
            <p>請仔細閱讀本協議，在您勾選“同意並繼續”選項後，即視為您已閱讀、理解並接受本協議的全部內容，並同意遵守相關規定。</p>

            <h3>• 協議主體</h3>
            <p>本協議由 IGE International Gold Exchange Limited（以下簡稱“平台”或“IGE”）與註冊並使用IGE RWA投資模式的用戶（以下簡稱“投資者”或“您”）共同簽署。</p>

            <h3>• 業務概述</h3>
            <ul>
                <li>2.1 IGE 通過 RWA（現實世界資產上鏈）技術，將黃金大宗交易數字化，讓普通投資者可參與全球黃金市場，實現低門檻投資。</li>
                <li>2.2 您可通過本平台投資黃金資產，並按平台規定獲得收益。</li>
                <li>2.3 您的投資本金將用於黃金交易業務，收益來源於黃金交易市場的價差利潤。</li>
            </ul>

            <h3>• 投資規則</h3>
            <ul>
                <li>3.1 最低投資金額：無固定門檻，用戶可根據自身需求自由投資。</li>
                <li>3.2 投資週期：7天（資產包滿後開始計時）</li>
                <li>3.3 收益率：標準為 1.2% / 7天，收益按投資金額計算，並在週期結束後返還至賬戶。</li>
                <li>3.4 收益發放：投資期滿後，用戶可選擇 提現 或 復投。</li>
                <li>3.5 提前退出：投資週期內不可提前退出，必須持有至期滿。</li>
                <li>3.6 如資產包無法在48小時內滿額，則全額退回投資資金至投資者賬戶。</li>
            </ul>

            <h3>• 資金管理</h3>
            <ul>
                <li>4.1 資金安全保障：您的資金用於黃金實物交易，全程由銀行、保險及第三方機構監督。</li>
                <li>4.2 提現規則：提現需遵循平台流程，鏈上通常在1-2分鐘內到賬。</li>
                <li>4.3 手續費：平台收取5‰ 手續費。</li>
            </ul>

            <h3>• 風險提示</h3>
            <ul>
                <li>5.1 流動性風險：投資需持有至期滿，不能提前贖回，請合理安排資金。</li>
                <li>5.2 不可抗力：因戰爭、政府政策調整、系統故障等不可抗力事件導致的損失，IGE 不承擔責任。</li>
            </ul>

            <h3>• 用戶權利與義務</h3>
            <ul>
                <li>6.1 您的權利
                <ul>
                    <li>有權查詢投資收益、提現、復投等相關信息。</li>
                    <li>有權在平台規定範圍內自由投資，並獲得相應回報。</li>
                </ul>
                </li>
                <li>6.2 您的義務
                <ul>
                    <li>確保提供的個人信息真實有效，不得冒用他人身份註冊或投資。</li>
                    <li>遵守國家相關法律法規及平台規則，不得利用平台進行非法活動。</li>
                </ul>
                </li>
            </ul>

            <h3>• IGE的權利與義務</h3>
            <ul>
                <li>7.1 平台承諾嚴格管理投資資金，確保黃金交易的合規性與透明度。</li>
                <li>7.2 平台有權在發現用戶存在違規行為時，暫停或終止用戶賬戶。</li>
            </ul>

            <h3>• 法律適用與爭議解決</h3>
            <ul>
                <li>8.1 本協議適用於平台業務所在地法律（如泰國或IGE總部所在地法律）。</li>
                <li>8.2 如發生爭議，雙方應友好協商解決，若協商不成，則提交當地法院裁決。</li>
            </ul>

            <h3>• 其他條款</h3>
            <ul>
                <li>9.1 本協議的最終解釋權歸 IGE 所有。</li>
                <li>9.2 IGE 有權根據市場情況更新協議內容，修改後的協議將在平台公示，用戶需重新閱讀並同意後繼續投資。</li>
                <li>9.3 IGE不對USDT未獲合法認可地區的用戶提供投資服務。</li>
            </ul>

            <p>請您確認已閱讀並理解本協議，如無異議，請點擊「同意」繼續投資。</p>
        </Agreement>

    )
}

const Agreement = styled('div')`
    font-family: "Noto Sans TC", sans-serif;
    line-height: 1.6;
    padding: 20px;
    color: #eaeaea;
    & h1, & h2 {
        text-align: center;
        margin-bottom: 10px;
    }
    & h3 {
        margin-top: 20px;
        font-weight: bold;
        color: #b3b3b3;
    }

    ul {
        margin-left: 20px;
    }
`